/* src/app/quickbooks/send-journal-entry/send-journal-entry-container/send-journal-entry-container.component.scss */
body#themeTag :host ::ng-deep .p-message .p-message-wrapper {
  padding: 0rem 1rem;
}
/*# sourceMappingURL=send-journal-entry-container.component.css.map */
